<template>
  <div id='top'>
    <h1>Running stats for {{$store.state.name}}</h1>
    <el-row>
      <el-col>
        <stats-card></stats-card>
        <el-card v-if="$store.state.photo.data.length > 0" class='photo-card' :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span>Last photo of chip {{$store.state.photo.chip_id}} in state {{$store.state.photo.state}}</span>
          </div>
          <el-row>
            <el-col :span="24"><img style="width:100%" :src="getImageData"></img></el-col>
          </el-row>
        </el-card>
        <sockets-card></sockets-card>
        <results-card v-if='hasResults'></results-card>
        <el-card class='chips-card' v-if='$store.state.chips.length > 0'>
          <div slot="header" class="clearfix">
            <span>Last chips tested</span>
          </div>
          <el-collapse>
            <chip-data v-for='chip in $store.state.chips' :key='chip.id' :chip="chip"></chip-data>
          </el-collapse>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import StatsCard from './stats-card'
  import ChipData from './chip-data'
  import SocketsCard from './sockets-card'
  import ResultsCard from './results-card'

  export default {
    name: 'project-progress',
    components: {
      StatsCard,
      ChipData,
      SocketsCard,
      ResultsCard
    },
    computed: {
      getImageData() {
        return 'data:image/jpg;base64,' + this.$store.state.photo.data
      },
      hasResults() {
        return 'stats' in this.$store.state.results
      },
      numSockets() {
        var ns = 0
        for( var ib = 0; ib < this.$store.state.boards.length; ib++ ) {
          var b = this.$store.state.boards[ib]
          ns += b.sockets.length
        }
        return ns
      }
    }
  }
</script>

<style scoped>
  h1 {
    padding-left: 15px;
  }
  #top {
    margin-top: 10px;
    height: 100%;
  }
  .el-card {
    margin: 10px;
    float: left;
  }
  .photo-card {
    width: 500px;
  }
  .chips-card {
    width: 550px;
  }
  .kv-key {
    text-align: right;
  }
  .kv-value {
    text-align: left;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

</style>



// WEBPACK FOOTER //
// project-progress.vue?c8bb6110